import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';


const Footer = ({ isCase }) => {
  const year = new Date().getFullYear();
  return (
    <div className="footer">
      <div className="footer__wrapper">
        <div className="footer__newsletter">
            <div className="footer__newsletter-text">
              <p>
            More documentary profiles of our workplaces are coming soon. We can email you when a new one comes out.
              </p>
            </div>

            <div className="footer__form">
              <form action="https://underdog.us8.list-manage.com/subscribe/post" className="footer-form" method="POST">
              <input type="hidden" name="u" value="61d5ad48b1d22e7dda21b54ee" />
              <input type="hidden" name="id" value="9d9aa6634b" />
              <input type="email" id="MERGE0" name="MERGE0" placeholder="E-mail address" required />
               <button type="submit" value="" name="submit"  className="btn footer-btn">Follow Workplaces</button>
               <input type="hidden" name="mc_signupsource" value="hosted" />


             </form>


            </div>
          </div>

        <div className="footer__nav">
          <ul className="footer__nav-list">
          <li>Underdog.io</li>
          <li>© Porter Labs Inc.</li>
          <li>2014—2018</li>
          <li><a href="https://underdog.io" target="_blank">Find a job</a></li>
         </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;

Footer.propTypes = {
  isCase: PropTypes.bool,
};

Footer.defaultProps = {
  isCase: false,
};



// WEBPACK FOOTER //
// ./src/components/Footer.jsx